




import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import SearchInput from '@/components/SearchInput.vue';
import * as config from './config';
@Component({
  components: {
    VoteList,
    SearchInput,
  },
})
export default class One extends Vue {
  options = config.OPTHINES;
}
